import { Field } from "formik";
import { FtextField } from "../../../../../components/common/FtextField";
import { useTranslation } from "react-i18next";

const SSLCommerz = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="displayGrid3">
        <FtextField
          required
          type="text"
          label={t("storeId")}
          name="settings.paymentGateway.sslCommerz.storeId"
          validation={true}
        />

        <FtextField
          required
          type="password"
          label={t("password")}
          name="settings.paymentGateway.sslCommerz.storePassword"
          validation={true}
        />
      </div>

      <div className="displayGrid3">
        <div className="form-check mt-4">
          <Field
            className="form-check-input"
            type="checkbox"
            id="sslCommerz"
            name="settings.paymentGateway.providers.sslCommerz"
          />
          <label className="form-check-label" for="sslCommerz">
            {t("hasGateway")} <span className="text-danger ms-1">*</span>
          </label>
        </div>

        <div className="form-check mt-4">
          <Field
            className="form-check-input"
            type="checkbox"
            id="hasPG"
            name="settings.paymentGateway.hasPG"
          />
          <label className="form-check-label" for="hasPG">
            {t("hasPG")} <span className="text-danger me-4">*</span>
          </label>
        </div>
      </div>
    </>
  );
};

export default SSLCommerz;
